<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-lg-12">
        <div class="row justify-content-start">
          <div class="col-lg-12 col-md-12 col-12">
            <div>
              <h2 class="text-white">Bienvenido {{ user.name }}</h2>
              <p class="text-white opacity-8 mb-4">Panel del operador</p>
            </div>
          </div>
          <div class="col-lg-3 col-md-6 col-12 d-flex justify-content-start mt-3">
            <router-link
              :to="{ name: 'OperatorProductionUser' }"
              class="card-link"
            >
              <div class="card card-background card-background-mask-primary tilt">
                <div class="full-background bg-gradient-primary"></div>
                <div class="card-body py-4">
                  <div class="d-flex">
                    <div class="icon icon-shape bg-white shadow rounded-circle">
                      <i class="ni ni-check-bold text-primary text-lg opacity-10"></i>
                    </div>
                    <div class="ms-3">
                      <h5 class="text-white font-weight-bolder mb-0">Mis tareas</h5>
                      <p class="text-white text-sm opacity-8 mb-0">Lista de tareas de producción</p>
                    </div>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'OperatorDashboard',
  data() {
    return {
      user: {},
    };
  },
  mounted() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.user = user || {};
  },
};
</script>

<style scoped>
.card-link {
  text-decoration: none;
  color: inherit;
}
</style>
